import 'jquery-validation'
import 'jquery-validation/dist/additional-methods'
import { getState } from "../helpers/getState";
import { updateCart } from "../helpers/updateCart";
import { getProduct } from "../helpers/getProduct";
import { getRout } from "../helpers/getRout";
import { setContacts } from "../helpers/setContacts";
import { subscribeForm } from "../helpers/subscribeForm";
import { routerIndex } from "../helpers/routerIndex";

updateCart()
getRout()
subscribeForm()

const $loader = $('.popup-loading-wrapper');

getState((data) => {

  console.log('state is loaded: ' + JSON.stringify(data.data))

  const products = data.data.products;

  if (data.data.processing) {
    console.log('processing: ' + data.data.processing)
    $loader.show()
    routerIndex(data.data)
  } else {
    $loader.hide();
  }

  setContacts(data.data.templates)

  getProduct(products, 'ha-product__content');

  getProduct(products, 'home-product__content');

  getProduct(products, 'banner-flex');

});
